import { Position } from '../../types'
import { useContext } from 'react'
import { useChannelsElementRect } from '../channels/hooks/useChannelsElementRect'
import { CutterContext } from '../contexts/CutterContext'

export function useVisiblePixelSize(): Position {
  const { visibleRange } = useContext(CutterContext)
  const { width } = useChannelsElementRect()

  return (visibleRange[1] - visibleRange[0]) / width
}
